/*
 * Copyright (c) 2021
 *    Reliant Business Valuation, LLC - https://valzy.com
 *    Author: Kirill Vizniuk - kirill@reliantvalue.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Component, OnInit } from '@angular/core';
import { CommonService, RegisterSvgService } from './services';

@Component({
  selector: 'iv-root',
  template: `
      <router-outlet></router-outlet>
      <app-my-loader></app-my-loader>
      <report-preview-loader></report-preview-loader>
      <toaster-container></toaster-container>`
})
export class AppComponent implements OnInit {
  windowObj;

  constructor(
    private commonService: CommonService,
    private registerSVG: RegisterSvgService
  ) {
    if (this.commonService.getOrgWindowObject) {
      this.windowObj = this.commonService.getOrgWindowObject;
      this.changeTheme();
    } else {
      this.setDefaultTheme();
    }
  }

  ngOnInit(): void {
    this.registerSVG.initializeSVG();
  }

  changeTheme() {
    document.documentElement.style.setProperty('--primary-color', this.windowObj.getPrimaryColor());
    document.documentElement.style.setProperty('--secondary-color', this.windowObj.getSecondaryColor());
    document.documentElement.style.setProperty('--disabled-color', this.windowObj.getDisabledColor());
  }

  setDefaultTheme() {
    document.documentElement.style.setProperty('--primary-color', '#4164E2');
    document.documentElement.style.setProperty('--secondary-color', '#ecf0fd');
    document.documentElement.style.setProperty('--disabled-color', '#a0b2f0');
  }

}
